import { render, staticRenderFns } from "./CompactEditMainComponent.vue?vue&type=template&id=bc46210c&scoped=true&"
import script from "./CompactEditMainComponent.vue?vue&type=script&lang=js&"
export * from "./CompactEditMainComponent.vue?vue&type=script&lang=js&"
import style0 from "./CompactEditMainComponent.vue?vue&type=style&index=0&id=bc46210c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc46210c",
  null
  
)

export default component.exports